/**
 * blog.js
 * Gère le slider et les filtres de la page blog.
 * Séparé de landing-range.js car la logique blog est indépendante des landing pages.
 */

(function () {
  'use strict';

  if (window.__lpBlogInit) return;
  window.__lpBlogInit = true;

  /* ── Slider articles (WP : perView 2 desktop / 1 mobile) ────────── */
  function initBlogSlider() {
    var el = document.querySelector('.glide-posts');
    if (!el || typeof Glide === 'undefined') return;

    var slides = el.querySelectorAll('.glide__slide-post');
    if (slides.length <= 1) return;

    try {
      new Glide(el, {
        type: 'slider',
        startAt: 0,
        perView: 2,
        gap: 20,
        breakpoints: {
          767: {
            perView: 1,
          },
        },
      }).mount();
    } catch (e) {
      /* Dégradation gracieuse si Glide non disponible */
    }
  }

  /* ── Slider articles liés (page article détail) ─────────────────── */
  function initRelatedSlider() {
    var el = document.querySelector('.glide-related');
    if (!el || typeof Glide === 'undefined') return;

    var slides = el.querySelectorAll('.glide__slide');
    if (slides.length <= 1) return;

    try {
      new Glide(el, {
        type: 'slider',
        startAt: 0,
        perView: 2,
        gap: 10,
        breakpoints: {
          1024: {
            perView: 2,
          },
          767: {
            perView: 1,
          },
        },
      }).mount();
    } catch (e) {
      /* Dégradation gracieuse si Glide non disponible */
    }
  }

  /* ── Filtrer bouton toggle ──────────────────────────────────────── */
  /* La visibilité du panel est gérée par CSS (hover + aria-expanded).
     Le JS gère uniquement aria-expanded pour le clic (mobile / clavier). */
  function initFilterToggle() {
    var toggle = document.querySelector('.posts-filters__toggle');
    if (!toggle) return;

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
    });

    /* Fermer sur clic extérieur (utile sur mobile sans hover) */
    document.addEventListener('click', function () {
      toggle.setAttribute('aria-expanded', 'false');
    });
  }

  function init() {
    initBlogSlider();
    initRelatedSlider();
    initFilterToggle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
